import { escapeCSV } from '@root/utils/Export';

const getLines = (doc) => {
  return doc.content
    .split('Company: ')[0]
    .split(/<br>|\n|<\/p><p>/)
    .map((l) => l.replace(/(<([^>]+)>)/gi, '').trim());
};

const getCsvContent = (docs) => {
  const csvContent = docs.reduce((csv, doc) => {
    const lines = getLines(doc);

    if (lines.length < 2) { // most likely malformed
      return csv;
    }

    const headline = lines[0];
    const blogIntro = lines.slice(1).filter((i) => !!i).join(' ').replace('Blog Intro:', '');

    return `${csv}"${escapeCSV(headline)}","${escapeCSV(blogIntro)}"\r\n`;
  }, '');

  return csvContent;
};

const getPdfContent = (docs) => {
  const pdfContent = docs.reduce((pdf, doc) => {
    const lines = getLines(doc);

    if (lines.length < 2) { // most likely malformed
      return pdf;
    }

    const headline = lines[0];
    const blogIntro = lines.slice(1).filter((i) => !!i).join(' ').replace('Blog Intro:', '');

    return `${pdf}"${headline}","${blogIntro}"\r\n\n`;
  }, '');

  return pdfContent;
};

const getTxtContent = (docs) => {
  const txtContent = docs.reduce((txt, doc) => {
    const lines = getLines(doc);

    if (lines.length < 2) { // most likely malformed
      return txt;
    }

    const headline = lines[0];
    const blogIntro = lines.slice(1).filter((i) => !!i).join(' ').replace('Blog Intro:', '');

    return `${txt}"${headline}","${blogIntro}"\r\n\n`;
  }, '');

  return txtContent;
};

export { getTxtContent, getCsvContent, getPdfContent };
